// The policy texts carry review notes for the lawyer and the owner:
// "[LAWYER: ...]", "[OWNER: ...]" and "[LAWYER/OWNER: ...]". A note may hold one
// blank of its own, such as "[COUNTY]". The notes stay in terms.js, privacy.js
// and refund.js, so those still match the lawyer's copy word for word, and are
// cut from what the public pages show. Blanks outside a note, such as
// "[CONTACT EMAIL]", stay visible until they are filled in.
//
// The spaces or tabs just before a note go with it, so "takes effect [LAWYER: x]."
// becomes "takes effect." and "States. [LAWYER: y] We" becomes "States. We".
const REVIEW_NOTE = /[ \t]*\[(?:LAWYER|OWNER)\b(?:[^[\]]|\[[^[\]]*\])*\]/g;

export const withoutReviewNotes = (markdown) => markdown.replace(REVIEW_NOTE, "");
